import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { BoxWrapper } from './CommonPurchase.styles';
import {
  ActionRow,
  DetailGrid,
  DetailItem,
  DocChip,
  DocChips,
  InfoBoxGrid,
  InfoCard,
  InfoCardHeader,
  InfoCardTitle,
  PrimaryActionButton,
  SectionLabel,
  StatusPill,
} from './InfoBoxV2.styles';
import ProductsTableCard from './ProductsTableCard';
// import MessagesModal from '../../../elements/MessagesModal';
import axe from '../../../../../services/axios-client/axiosClient';
import { downloadFile } from '../../../../../services/axios-client/axeHelpers';
import { apiDownloadDocument } from '../../../../../services/axios-client/axeCommons';
import { getDDFDocument } from '../../../../constants';
import { getBrokeragePerPayment, isNewBrokerageSystem } from '../../../../helpers/brokerageHelpers';

function InfoBoxSalute({
  insuranceRequest,
  // messagesModalData,
  statuses,
  rc_quotation,
  risk_quotations,
}) {
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const downloadResourceDocs = async (id) => {
    const res = await axe.get(`/download-resource-document/${id}/0`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  const downloadPreventive = async () => {
    const res = await axe.get(
      `/quotations/${rc_quotation.id}/preventivo/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  const DDF_document = getDDFDocument(rc_quotation, insuranceRequest);

  const downloadDocument = async (documentId) => {
    if (documentId === undefined) {
      return;
    }
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (rc_quotation !== null) {
      quoteInProccessAmount = parseFloat(rc_quotation.amount);
    }

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        risksTotalAmount += parseFloat(item.amount);
      }
    }

    const total = quoteInProccessAmount + risksTotalAmount + (rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) ? 0 : getBrokeragePerPayment(rc_quotation));

    return total.toFixed(2);
  };

  return (
    <>
      <BoxWrapper>
        <InfoBoxGrid>
          <InfoCard className="documents-status-step-one pagament-status-step-one">
            <InfoCardHeader>
              <InfoCardTitle>Riepilogo</InfoCardTitle>
              <StatusPill>{statuses.find((stat) => stat.id === rc_quotation.status).name}</StatusPill>
            </InfoCardHeader>
            <DetailGrid>
              <DetailItem className="full">
                <dt>Cliente</dt>
                <dd>
                  {insuranceRequest.customer.name}
                  {' '}
                  {insuranceRequest.customer.surname}
                </dd>
              </DetailItem>
              <DetailItem className="full">
                <dt>Residenza</dt>
                <dd>
                  {`${insuranceRequest.customer.address} ${insuranceRequest.customer.house_number}, ${insuranceRequest.customer.postal_code} ${insuranceRequest.customer.city_of_residence.name} `
                  + `(${insuranceRequest.customer.city_of_residence.communal_territory.car_plate_symbol})`}
                </dd>
              </DetailItem>
              <DetailItem>
                <dt>Tipo Di Lavoro</dt>
                <dd>
                  {insuranceRequest.work_type === 'attivita_manuali'
                    ? 'Attivita Manuali'
                    : 'Attivita non Manuali'}
                </dd>
              </DetailItem>
              <DetailItem>
                <dt>Decorrenza</dt>
                <dd>
                  {moment(insuranceRequest.policy_effective_date).format(
                    'DD-MM-YYYY',
                  )}
                </dd>
              </DetailItem>
            </DetailGrid>

            <SectionLabel>Documenti</SectionLabel>
            <DocChips>
              {rc_quotation.company_id === 8 && (
                <DocChip type="button" onClick={() => downloadResourceDocs(16)}>
                  Informazioni Precontrattuali Europe Assistance
                </DocChip>
              )}
              <DocChip type="button" onClick={() => downloadPreventive()}>
                Preventivo
              </DocChip>
            </DocChips>

            <ActionRow>
              <PrimaryActionButton
                type="button"
                onClick={() => downloadDocument(DDF_document.id)}
              >
                Scarica Documento Da Firmare
              </PrimaryActionButton>
            </ActionRow>
          </InfoCard>

          <ProductsTableCard total={getTotal()}>
            <tr>
              <td style={{ maxWidth: '260px', whiteSpace: 'normal', wordBreak: 'break-word' }}>{rc_quotation.product.name}</td>
              <td>
                {rc_quotation.company_id !== null
                  ? rc_quotation.company.name
                  : rc_quotation.preventivas_company.company_name}
              </td>
              <td>
                {parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            {risk_quotations
              && risk_quotations.map((quote, index) => (
                <tr key={index}>
                  <td style={{ maxWidth: '260px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {
                      quoteTypes.find(
                        (type) => type.id === quote.quote_type,
                      ).name
                    }
                  </td>
                  <td>{quote.company.name}</td>
                  <td>
                    {parseFloat(quote.amount).toFixed(2)}
                    {' '}
                    &euro;
                  </td>
                </tr>
              ))}
            <tr>
              <td>
                Brokeraggio
                {rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) && <span className="text-success fw-bold"> (Pagato)</span>}
              </td>
              <td />
              <td>
                {parseFloat(getBrokeragePerPayment(rc_quotation)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            <tr>
              <td>Spese Di Emissione</td>
              <td />
              <td>
                {rc_quotation.payment_frequency === 1
                  ? parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)
                  : parseFloat(
                    (parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0))
                    / rc_quotation.payment_frequency,
                  ).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
          </ProductsTableCard>
        </InfoBoxGrid>
      </BoxWrapper>
      {/* <MessagesModal
        {...messagesModalData}
        threads={insuranceRequest.threads}
      /> */}
    </>
  );
}

export default InfoBoxSalute;
